import React from 'react';

const FormRowBuildings = ({
  labelText = '',
  buildings = [],
  selectedBuildings = [],
  handleBuildingSelection,
  handleSelectAll,
}) => {

  return (
    
      <div style={{ display: 'flex', flexDirection: 'column',marginBottom: '1rem' }}>
        <button
          type='button'
          className='btn'
          onClick={handleSelectAll}
          style={{ marginBottom: '10px', alignSelf: 'start' }}
        >
          בחר/בטל הכל
        </button>

        <div
          className='checkbox-group'
          style={{
            maxHeight: '200px',
            overflowY: 'auto',
            border: '1px solid #ccc',
            borderRadius: '5px',
            padding: '30px',
          }}
        >
          {buildings.map((building) => (
            <label key={building.id} style={{ display: 'block', marginBottom: '5px' }}>
              <input style={{ marginLeft: '10px' }}
                type='checkbox'
                name='selectedBuildings'
                value={building.id}
                checked={selectedBuildings.includes(building.id)}
                onChange={() => handleBuildingSelection(building.id)}
              />
              {`${building.city} - ${building.street} ${building.houseNumber}  `}
              <strong>{building.nickname ? `(${(building.nickname)})` : ""}</strong>
            </label>
          ))}
        </div>
      </div>
  );
};

export default FormRowBuildings;
